import { Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-service-layout2',
  templateUrl: './service-layout2.component.html',
  styleUrls: ['./service-layout2.component.scss']
})
export class ServiceLayout2Component {
 constructor( private commonService: CommonService,) {
  }

  public serverPath = environment.commonImageApi + '/commonSlider/';

  public serverPath1 = environment.commonImageApi + '/home/';

  @Input() item: any;

  @Input() img: any;

  openInNewWindow(url: string) {
    if (url) {
      const fullURL = this.prependProtocol(url);
      this.commonService.goToLink(url)
    }
  }

  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }


  @ViewChildren('stepElement') stepElements!: QueryList<ElementRef>;
  activeState: string[] = [];
  
  ngAfterViewInit() {
    // Initialize the active state array with empty strings
    this.activeState = new Array(this.stepElements.length).fill('');
  
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const idx = this.stepElements.toArray().findIndex(el => el.nativeElement === entry.target);
        if (idx === -1) return; // Skip if index not found
  
        if (entry.isIntersecting) {
          const ratio = entry.intersectionRatio;
          if (ratio < 0.8) {
            this.activeState[idx] = `step-in-${idx}`;
          } else {
            this.activeState[idx] = 'step-middle';
          }
        } else {
          // Exit animation depending on scroll direction
          this.activeState[idx] = `step-out-${idx}`;
        }
      });
    }, { threshold: [0, 0.8, 1] });
  
    // Start observing each step element
    this.stepElements.forEach((el) => {
      observer.observe(el.nativeElement);
    });
  }
  
  getScrollClass(index: number): string {
    return this.activeState[index] || '';
  }
  
}
